import React from "react";
import {
  Box,
  Button,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import TextFieldsRoundedIcon from "@mui/icons-material/TextFieldsRounded";
import PaletteRoundedIcon from "@mui/icons-material/PaletteRounded";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import FormatSizeRoundedIcon from "@mui/icons-material/FormatSizeRounded";
import ImageRoundedIcon from "@mui/icons-material/ImageRounded";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";

const TOOLS = [
  { id: "content", label: "Textos", icon: TextFieldsRoundedIcon },
  { id: "colors", label: "Colores", icon: PaletteRoundedIcon },
  { id: "style", label: "Estilo", icon: TuneRoundedIcon },
  { id: "type", label: "Tipografía", icon: FormatSizeRoundedIcon },
  { id: "image", label: "Imágenes", icon: ImageRoundedIcon },
];

export default function LandingSegmentToolbar({
  sectionId,
  label,
  enabled,
  canToggle,
  onToggle,
  onOpenTool,
}) {
  const compact = useMediaQuery("(max-width:900px)");

  return (
    <Box
      className="landing-segment-toolbar"
      onClick={(event) => event.stopPropagation()}
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: { xs: "flex-start", md: "flex-end" },
        px: { xs: 0.75, sm: 1 },
        py: 0.65,
        bgcolor: "rgba(244,245,247,.96)",
        borderBottom: "1px solid rgba(25,36,47,.08)",
        pointerEvents: "auto",
      }}
    >
      <Stack
        direction="row"
        spacing={0.45}
        alignItems="center"
        sx={{
          width: { xs: "100%", md: "auto" },
          maxWidth: "100%",
          p: 0.55,
          borderRadius: 999,
          bgcolor: "rgba(25,36,47,.94)",
          color: "#fff",
          boxShadow: "0 12px 36px rgba(25,36,47,.28)",
          backdropFilter: "blur(12px)",
          overflowX: "auto",
          overscrollBehaviorX: "contain",
          WebkitOverflowScrolling: "touch",
          touchAction: "pan-x",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        <Typography
          variant="caption"
          noWrap
          sx={{
            pl: 1,
            pr: 0.65,
            maxWidth: compact ? 110 : 190,
            flexShrink: 0,
            fontWeight: 950,
          }}
        >
          Editando · {label}
        </Typography>

        {TOOLS.map(({ id, label: toolLabel, icon: Icon }) =>
          compact ? (
            <Tooltip title={toolLabel} key={id}>
              <IconButton
                size="small"
                aria-label={`${toolLabel} de ${label}`}
                onClick={() => onOpenTool(sectionId, id)}
                sx={{
                  width: 42,
                  height: 42,
                  flexShrink: 0,
                  color: "#fff",
                  bgcolor: "rgba(255,255,255,.08)",
                }}
              >
                <Icon fontSize="small" />
              </IconButton>
            </Tooltip>
          ) : (
            <Button
              key={id}
              size="small"
              startIcon={<Icon fontSize="small" />}
              onClick={() => onOpenTool(sectionId, id)}
              sx={{
                minWidth: 0,
                px: 1.05,
                color: "#fff",
                borderRadius: 999,
                textTransform: "none",
                fontWeight: 850,
                "&:hover": { bgcolor: "rgba(255,255,255,.12)" },
              }}
            >
              {toolLabel}
            </Button>
          )
        )}

        {canToggle ? (
          compact ? (
            <Tooltip title={enabled ? "Ocultar sección" : "Mostrar sección"}>
              <IconButton
                size="small"
                aria-label={enabled ? "Ocultar sección" : "Mostrar sección"}
                onClick={() => onToggle(!enabled)}
                sx={{
                  width: 42,
                  height: 42,
                  flexShrink: 0,
                  color: enabled ? "#fff" : "#F9B4A6",
                  bgcolor: "rgba(255,255,255,.08)",
                }}
              >
                {enabled ? (
                  <VisibilityOffRoundedIcon fontSize="small" />
                ) : (
                  <VisibilityRoundedIcon fontSize="small" />
                )}
              </IconButton>
            </Tooltip>
          ) : (
            <Button
              size="small"
              startIcon={
                enabled ? (
                  <VisibilityOffRoundedIcon fontSize="small" />
                ) : (
                  <VisibilityRoundedIcon fontSize="small" />
                )
              }
              onClick={() => onToggle(!enabled)}
              sx={{
                minWidth: 0,
                px: 1.05,
                flexShrink: 0,
                color: enabled ? "#fff" : "#F9B4A6",
                borderRadius: 999,
                bgcolor: "rgba(255,255,255,.08)",
                textTransform: "none",
                fontWeight: 850,
                "&:hover": { bgcolor: "rgba(255,255,255,.14)" },
              }}
            >
              {enabled ? "Ocultar" : "Mostrar"}
            </Button>
          )
        ) : null}
      </Stack>
    </Box>
  );
}
